import { getBasketballStatisticHeader } from '@utils/statistic/basketball';
import { getHockeyStatisticHeader } from '@utils/statistic/hockey';
import { getVolleyballStatisticHeader } from '@utils/statistic/volleyball';
import { Sport } from '@mtgame/core';
import { getHandballStatisticHeader } from '@utils/statistic/handball';
import { getFootballStatisticHeader } from '@utils/statistic/football';
import { getStreetballStatisticHeader } from '@utils/statistic/streetball';
import { getRugbyStatisticHeader } from '@utils/statistic/rugby';

export function getStatisticHeader(sport: Sport, goalie?: boolean, light?: boolean, forTeam?: boolean) {
  if (sport.isStreetball()) {
    return getStreetballStatisticHeader(light);
  }
  if (sport.isBasketball()) {
    return getBasketballStatisticHeader(light);
  }
  if (sport.isHockey()) {
    return getHockeyStatisticHeader(goalie);
  }
  if (sport.isVolleyball()) {
    return getVolleyballStatisticHeader(light);
  }
  if (sport.isHandball()) {
    return getHandballStatisticHeader(goalie, forTeam);
  }
  if (sport.isFootball()) {
    return getFootballStatisticHeader(goalie, forTeam);
  }
  if (sport.isRugby()) {
    return getRugbyStatisticHeader();
  }
}
